export default class EstatedTax {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.year = obj.year;
    this.amount = obj.amount;
    this.exemptions = obj.exemptions;
    this.rate_code_area = obj.rate_code_area;
  }
}
